import { RECURRENCE_TYPES } from "lib/constants";
import * as Yup from "yup";

const validationSchema = [
  Yup.object().shape({
    info: Yup.object().shape({
      name: Yup.string()
        .max(100, "Name cannot be more than 100 characters")
        .required("Template Name is required"),
      color: Yup.string().required("Color is required").typeError("Color is required"),
      description: Yup.string()
        .max(255, "Description cannot be more than 255 characters")
        .required("Description is required"),
      visiblity: Yup.string().required("Visibility is required"),
    }),
  }),
  Yup.object().shape({
    cadence: Yup.object().shape({
      dueDateOption: Yup.string()
        .required("This field is required")
        .typeError("This field is required"),
      dueDateNum: Yup.number()
        .required("This field is required")
        .typeError("This field is required"),
      type: Yup.string().required("Type is required").typeError("Type is required"),
      days: Yup.string().when("type", {
        is: (type) =>
          type === RECURRENCE_TYPES.WEEKLY ||
          type === RECURRENCE_TYPES.MONTHLY ||
          type === RECURRENCE_TYPES.QUARTERLY,
        then: Yup.string().required("Day is required").typeError("Day is required"),
        otherwise: Yup.string().nullable(),
      }),
      monthOfYear: Yup.string().when("type", {
        is: (type) => type === RECURRENCE_TYPES.ANNUALLY,
        then: Yup.string().required("Month is required").typeError("Month is required"),
        otherwise: Yup.string().nullable(),
      }),
      dayOfMonth: Yup.string().when("type", {
        is: (type) => type === RECURRENCE_TYPES.ANNUALLY,
        then: Yup.string().required("Day is required").typeError("Day is required"),
        otherwise: Yup.string().nullable(),
      }),
    }),
  }),
  Yup.object().shape({
    questions: Yup.array()
      .of(
        Yup.object().shape({
          question: Yup.string().required("Question is required"),
          type: Yup.string()
            .required("Answer Type is required")
            .typeError("Answer Type is required"),
          childQuestion: Yup.string().when("type", {
            is: (type) => type === "pipeline health",
            then: Yup.string()
              .required("Child Question is required")
              .typeError("Child Question is required"),
            otherwise: Yup.string().nullable(),
          }),
        })
      )
      .min(1, "Add atleast one question"),
  }),
  Yup.object().shape({
    // eslint-disable-next-line react/forbid-prop-types
    assignTo: Yup.array(),
  }),
];

export const validationSchemaForUserSpecific = [
  Yup.object().shape({
    // eslint-disable-next-line react/forbid-prop-types
    template: Yup.object().required("Template is required").typeError("Template is required"),
  }),
  validationSchema[1],
  validationSchema[2],
];

export default validationSchema;
